import React from 'react';

import { ProductCarousel as ProductCarouselV2 } from 'src/components/carousel-v2/types/product-carousel';
import type { MenuSection } from 'src/gql/graphql';
import { useReportCarouselRenderState } from 'src/components/carousels/carousel-render-state';
import { useRecentlyViewedCarousel } from './use-recently-viewed-carousel';

export type RecentlyViewedCarouselProps = {
  section?: MenuSection;
  sectionIndex?: number;
  excludeProductId?: string;
  /**
   * Optional caller-supplied heading, used by the CMS Product Carousel block. Takes
   * precedence over `section.label`, which the homepage keeps supplying unchanged.
   */
  title?: string;
  /** Set to false to render the carousel with no heading, matching the sibling carousels. */
  showTitle?: boolean;
};

export function RecentlyViewedCarousel(props: RecentlyViewedCarouselProps): JSX.Element | null {
  const { section, excludeProductId, title, showTitle } = props;
  const label = `Recently Viewed`;

  const carouselProps = useRecentlyViewedCarousel({
    excludeProductId,
  });
  const { products, loading } = carouselProps;
  useReportCarouselRenderState({ loading, hasContent: products.length > 0 });

  if (!loading && !products.length) {
    return null;
  }

  return (
    <ProductCarouselV2
      products={products}
      isLoading={loading}
      title={title ?? section?.label ?? label}
      analyticsSection={section?.legacyLabel ?? label}
      hideTitle={showTitle === false}
    />
  );
}
